import TimeSliderController from "../app/TimeSliderController";
import store from "../app/store";
import rootScope from "../app/rootScope";

class ObsTimeSliderController extends TimeSliderController{


    constructor(view, staticAnimation, preloadedAnimation) {
        super(view, staticAnimation);

    }


    update(calendar){

        this.calendar = calendar;

        let tsnow = calendar.bestTs( new Date ()),
            tsnowstr = calendar.ts2hour(tsnow),
            selectedTs = calendar.bestTs(this.getTimestamp()),
            selectedTsStr = calendar.ts2day(selectedTs);


        const premium = store.get("premium");
        const timesteps = calendar.timestamps.map(
            function( ts ){
                let hourstr = calendar.ts2hour(ts);

                return  {ts, text: hourstr, premium: false };
            }
        );

        if (!premium){
            const premiumTimesteps = [];
            const lastTs = calendar.timestamps[0] - calendar.step;
            const firstTs = lastTs - 1800 * 1000;
            for (let ts = firstTs; ts <= lastTs; ts += calendar.step ){
                let hourstr = calendar.ts2hour(ts);
                premiumTimesteps.push({ts, text: hourstr, premium: true});
            }
            timesteps.unshift(...premiumTimesteps);
        }

        this.view.updateTimeSteps(
            timesteps,
            { ts: tsnow, text: tsnowstr },
            { ts: selectedTs, text: selectedTsStr},
            rootScope.resourcesServer ? rootScope.resourcesServer  : ""
        );

    }

}

export default ObsTimeSliderController;
